<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        (click)="dismissModal(false)"
        data-cy="will-call-confirmation-close-modal-button"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <h2 data-cy="will-call-confirmation-convert-order-label">
      {{ 'i18n.convertToWillCall.convertOrderToWillCall' | translate }}
    </h2>
  </ion-toolbar>
</ion-header>

<ion-content
  [scrollY]="true"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <p data-cy="will-call-confirmation-convert-order-message-label">
    {{ 'i18n.convertToWillCall.convertOrderConfirmMessage' | translate }}
  </p>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  *ngIf="(platformService?.isTouchExperience$ | async) === false"
>
  <div class="confirm-buttons">
    <ion-button
      [disabled]="(isOnline$ | async) === false"
      (click)="dismissModal(true)"
      data-cy="will-call-confirmation-convert-order-button"
      class="usf-fill-green-dsktp-tblt-modal-button"
    >
      {{ 'i18n.convertToWillCall.convertOrder' | translate }}
    </ion-button>
    <a
      (click)="dismissModal(false)"
      data-cy="will-call-confirmation-cancel-button"
      >{{ 'i18n.common.cancel' | translate }}</a
    >
  </div>
</ion-footer>

<ion-footer
  class="ion-footer-modal"
  *ngIf="platformService?.isTouchExperience$ | async"
>
  <ion-button
    [ngClass]="
      platformService.platformType !== platformService.platformEnum.mobile
        ? 'usf-outline-green-dsktp-tblt-modal-button'
        : 'usf-outline-green-mobile-modal-button'
    "
    (click)="dismissModal(false)"
    data-cy="will-call-confirmation-mobile-cancel-button"
    class="confirm-button-touch"
  >
    {{ 'i18n.common.cancel' | translate }}
  </ion-button>
  <ion-button
    [disabled]="(isOnline$ | async) === false"
    [ngClass]="
      platformService.platformType !== platformService.platformEnum.mobile
        ? 'usf-fill-green-dsktp-tblt-modal-button'
        : 'usf-fill-green-mobile-modal-button'
    "
    (click)="dismissModal(true)"
    data-cy="will-call-confirmation-mobile-convert-button"
    class="confirm-button-touch"
  >
    {{ 'i18n.convertToWillCall.convertOrder' | translate }}
  </ion-button>
</ion-footer>
